<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="80" inline>
        <FormItem label="科室名称">
          <Input placeholder="请输入" v-model="table.search.departmentName" clearable></Input>
        </FormItem>
        <FormItem label="科室编码">
          <Input placeholder="请输入" v-model="table.search.departmentCode" clearable></Input>
        </FormItem>
        <!-- <FormItem label="科室类型">
          <Select class="w-250" v-model="table.search.departmentName" clearable>
            <Option
              v-for="(item, index) in deparmentSelect"
              :value="item.value"
              :key="index"
            >{{ item.label }}</Option>
          </Select>
        </FormItem> -->
      
      </Form>
      <!--操作区域-->
      <div>
        <Button class="mr-3" type="success" @click="search">查询</Button>
        <Button class="mr-3" type="primary" @click="toAdd">新增</Button>
        <Button class="mr-3" type="warning" @click="deleteBatch">批量删除</Button>
      </div>

    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

      <!--详细-->
    <Modal v-model="detailModal" title="科室详细" :footer-hide="true" >
      <departmentdetail :currentId="currentId" v-if="detailModal" @close="detailModal=false"></departmentdetail>
    </Modal>

  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import departmentdetail from "../department/detail.vue";

export default {
  components: { DataTable ,departmentdetail},
  data: function () {
    return {
      currentId:"",
      detailModal:false,
      selectionData: [],
      table: {
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "科室名称", key: "departmentName" },
          { title: "科室编码", key: "departmentCode" },
          { title: "科室类型", key: "departmentType"},
          { title: "所属机构名称", key: "organName" },
          {
            title: "操作",
            width:"180px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row.departmentID);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#FA6266',
                    },
                    on: {
                      click: () => {
                        this.deleteSingle(params.row.departmentID);
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        apiUrl: "department/getlist",
        search: {
          departmentName: "",
          departmentCode:""
        },
      },
      deparmentSelect: [
        {
          value: "0",
          label: "类型一",
        },
        {
          value: "1",
          label: "类型二",
        },
      ],
    };
  },

  created: function () {},
  // 实例被激活时使用，用于重复激活一个实例的时候'
  activated () {
    this.search()
    // console.log('实例被激活时使用，用于重复激活一个实例的时候')
  },
  //   deactivated () {
  //     console.log('实例没有被激活时')
  // },
  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (id) {
      this.detailModal=true;
      this.currentId=id;
    },

    toAdd: function () {
      this.$router.push({ path: "departmentAdd" });
    },

    toEdit: function (data) {
      this.$router.push({ path: "departmentEdit", query: { id: data.departmentID } });
    },

    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "确认要删除该科室？",
        mask: false,
        onOk: () => {
          this.$api.post(`/department/delete?id=${id}`).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("删除成功");
              this.search();
            }
          });
        },
      });
    },

    //批量删除
    deleteBatch() {
      if (this.selectionData.length < 1) {
        this.$Message.warning("请先勾选数据");
      } else {
        let ids = [];
        this.selectionData.forEach((item) => {
          ids.push(item.departmentID);
        });
        let _ids = ids.join(";");
        this.$Modal.confirm({
          title: "确认要批量删除选中的数据？",
          mask: false,
          onOk: () => {
            this.$api.post(`/department/deleteBatch?ids=${_ids}`).then((rsp) => {
             if (rsp != false) {
              this.$Message.success("删除成功");
              this.search();
            }
            });
          },
        });
      }
    },

    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style scoped>
</style>